import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebcamSnapshotComponent } from './webcam-snapshot.component';
import { ImageCropperModule } from '../image-cropper/image-cropper.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    exports: [WebcamSnapshotComponent],
    imports: [CommonModule, ImageCropperModule, TranslateModule, MatIconModule, WebcamSnapshotComponent]
})
export class WebcamSnapshotModule {
}
